import { MessageSquare, Phone, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const identifyPaymentFailureRecoveryCallAr: TemplateAr = {
  name: 'رصد فشل الدفع + مكالمة استرداد',
  description:
    'الذكاء الاصطناعي يرصد المدفوعات الفاشلة ويُطلق مكالمات استرداد متعاطفة لتحديث وسيلة الدفع ومنع التسرّب.',
  category: 'ذكاء الإيرادات',
  workflow: [
    { icon: MessageSquare, label: 'فشل الدفع' },
    { icon: Sparkles, label: 'الـ AI يرصد' },
    { icon: Phone, label: 'مكالمة استرداد', final: true },
  ],
  detailDescription: {
    paragraph1:
      'اتصل بالعميل أول ما تفشل دفعته، وامنع التسرّب غير الطوعي. الـ AI يرصد الدفعة الفاشلة أو البطاقة المنتهية أو مشكلة الفوترة، ويتصل بتعاطف عشان يساعد العميل يحدّث وسيلة دفعه. ويعرض خيارات دفع متعددة، ويقدر يعالج الدفعة عبر الهاتف بأمان.',
    paragraph2:
      'نتائج الاسترداد تلقاها في نظام الفوترة أو منصة إدارة الاشتراكات أو أدوات تحليل الإيرادات عندك. والـ AI يحسّن توقيت المكالمة على أساس أنماط نجاح الاسترداد. والدفعة اللي ترجع تشغّل رسالة التأكيد واستعادة الخدمة تلقائياً.',
  },
  benefits: [
    'ترجع ٦٠-٨٠٪ من المدفوعات الفاشلة',
    'تمنع التسرّب غير الطوعي اللي سببه الفوترة',
    'مكالمة متعاطفة تحفظ العلاقة',
    'العميل يحدّث وسيلة دفعه فوراً',
    'تسرّب الإيراد ينزل وتلاحظ الفرق',
    'إعادة المحاولة والمتابعة تجري تلقائياً',
  ],
};
